import React, { FC, useContext, useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { 
	Avatars, 
	ChoosenSolutionCardsStatistics, 
	Footer, 
	PlayerImageAndUpScore, 
	PostMatchSummaryMolecule, 
	Scoreboard, 
	SolutionCardsStatistics, 
	StrengthCardsStatistics
} from "..";

import { BoardContext, CardContext, TeamContext } from "../../../context";
import { ArrowJumpingInStraightLine } from "../../atoms";
import PdfIndex from "./Pdf/PdfIndex";
import { useTranslation } from "react-i18next";

export interface IStatistics {
	strengthStatistic: any;
	solutionStatistic: any;
	playerWithMostSolution: any;
	playerWithMostUpper: any;
	teamLeaderBoard: any;
	challengeCardsHistory: any;
	solutionStatisticPerPlayer: any[];
	chosenSolutionCards: any[];
	playerFeedback: any;
}

const StatisticsMolecule: FC<{}> = () => {
	const { t } = useTranslation();
	const { setisGameInPostGamePhase } = useContext(BoardContext);
	const { teamNumber } = useContext(TeamContext);
	const { threeActions } = useContext(CardContext);

	const history = useHistory();

	const [recievedStatistics, setRecievedStatistics] = useState<IStatistics>();
	const [isStatisticsAlreadyDownloaded, setIsStatisticsAlreadyDownloaded] = useState<boolean>(false);
	const [pdfForEmail, setPdfForEmail] = useState<Blob>();
	 
	const myEmail = localStorage["userEmailInCaseHeLogsOut"];
	const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

	useEffect(() => {
		setisGameInPostGamePhase(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let data = {
			matchId: urlTokenExtracted,
			gameId: urlTokenExtracted,
			email: myEmail,
		}

		fetch(process.env.REACT_APP_BACKEND_URL + "api/post-games/statistic", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(res => res.json()).then(data => {
				setRecievedStatistics(data);
			})
			.catch((err) => {
				console.error(err);
			});

	}, [urlTokenExtracted, myEmail, teamNumber]);
	
    const sendPdfToEmail = () => {
        if(pdfForEmail){
            const myEmail = localStorage["userEmailInCaseHeLogsOut"];
            const formData = new FormData();
    
            formData.append("email", myEmail);
            formData.append("statisticsPDF", pdfForEmail); 
			const object = Object.fromEntries(formData)
            axios.post(
                process.env.REACT_APP_BACKEND_URL +"api/post-games/send-summary-pdf",
                formData,
                {headers: {"Content-type": "multipart/form-data"}}
            ).catch((err) => console.error(err) );

			history.push( "/goodbye/" + urlTokenExtracted);  
        }
    }

	const findUserEmailFromTheObject = () => {
		if (!recievedStatistics) 
			return <p></p>;

		let playerEmail = localStorage["userEmailInCaseHeLogsOut"];

		return recievedStatistics?.playerWithMostUpper.find((playerWithMostUpper: any) => playerWithMostUpper.email === playerEmail)?.email;
	}

	const getPlayersFullNameBasedOnTheEmail = (playerEmail: string) => {
		const currentUserFullName = recievedStatistics?.solutionStatisticPerPlayer.find((solutionStatisticsPerPlayer: any) => solutionStatisticsPerPlayer?.player?.email === playerEmail)?.player?.fullName;
		localStorage.setItem("currentUserFullName", currentUserFullName);
	}

	if (!recievedStatistics)
		return (<div></div>)

	let myTeamNumber = recievedStatistics.solutionStatisticPerPlayer.find( (playerStatistics: any) => playerStatistics.player.email === myEmail).teamNumber;
	
	return (
		<React.Fragment> 
			{getPlayersFullNameBasedOnTheEmail(findUserEmailFromTheObject())}
			<ArrowJumpingInStraightLine />
			<Avatars playerWithMostUpper={recievedStatistics.playerWithMostUpper} />
			<PlayerImageAndUpScore playerWithMostUpper={recievedStatistics.playerWithMostUpper} />
			<div className="vertical_line"></div>
			<h3 className="scoreboard_headline"> {t("scoreBoardText")} </h3>
			<Scoreboard scoreboard={recievedStatistics.playerWithMostUpper} />
			<div className="horizontal_line_two"></div>
			<StrengthCardsStatistics strengthStatistic={recievedStatistics.strengthStatistic} />
			<div className="horizontal_line_three"></div>
			<SolutionCardsStatistics solutionStatistic={recievedStatistics.solutionStatisticPerPlayer} teamNumber={myTeamNumber}/>
			<div className="horizontal_line_seven"></div>

			<h3 className="chosen_solution_cards_heading"> {t("yourSolutionCardsThatDilemaOwnerChoseText")} </h3>
			<ChoosenSolutionCardsStatistics solutionCards={recievedStatistics.chosenSolutionCards} />
			<div className="horizontal_line_five"></div>
			<PostMatchSummaryMolecule />
			<PdfIndex 
				pdfType="statistics" 
				recievedStatistics={recievedStatistics} 
				teamNumber={myTeamNumber} 
				threeActions={threeActions} 
				isDownloadButton={true} 
				setPdfForEmail={setPdfForEmail}
				sendEmailWithPdf={sendPdfToEmail}
				setIsStatisticsAlreadyDownloaded={setIsStatisticsAlreadyDownloaded} 
			/>
			{/* <Footer 
				sendEmailWithPdf={sendPdfToEmail}
			/> */}
		</React.Fragment>
	);
};

export default StatisticsMolecule;
